const dictionary = {
  en: {
    locale: 'en',
    messages: {
      hello: 'hello',
      login: 'Login',
      logout: 'Logout',
      backToEvent: 'Back To Event',
      callMentor: 'Mentor',
      mentor: 'Mentor',
      edit: 'Edit',
      team: 'Team',
      readArticle: 'Read Article',
      support: 'Support',
      history: 'History',
      watch: 'Watch',
      username: 'Username',
      password: 'Password',
      createArticle: 'Create Article',
      articleName: 'Article Name',
      workshopName: 'Workshop Name',
      create: 'Create',
      createWorkshop: 'Create Workshop',
      specifyNameAndTypeOfWorkshop: 'Please specify the name of the workshop.',
      zharfaStudentSociety: 'Zharfa Student Society',
      rastaScientificExtensiveSociety: 'Rasta Scientific Extensive Society',
      end: 'End',
      goNext: 'Go Next',
      retry: 'Retry',
      pickedCorrect: 'Correct',
      pickedIncorrect: 'Incorrect',
      checkAnswer: 'Check Answer',
      expertsGame: 'Experts Game',
      endOfFirstLevel: 'End Of First Level',
      startGame: 'Start Game',
      score: 'Score',
      thereIsNoItem: 'There Is No Item!',
      createWidget: 'Create Widget',
      removeState: 'Remove State',
      createState: 'Create State',
      help: 'Help',
      helpNumber: 'Help',
      createHelp: 'Create Help',
      widgetType: 'Widget Type',
      wantDeleteState: 'Do you want to delete this state?',
      eventTeam: 'Event Team',
      seeMore: 'See More',
      gameTheory: 'Game Theory',
      blockchain: 'Blockchain',
      gravity: 'Gravity',
      AI: 'Artificial Intelligence',
      algorithm: 'Algorithm',
      codingTheory: 'Coding Theory',
      chooseNextState: 'Choose Next State',
      next: 'Next',
      submit: 'Submit',
      answer: 'Answer',
      submitAnswer: 'submitAnswer',
      question: 'Question',
      game: 'Game',
      chooseTheGame: 'Choose The Game',
      removeWidget: 'Remove Widget',
      wantRemoveWidget: 'Do you want to remove this widget?',
      options: 'Options',
      back: 'Back',
      longAnswerQuestion: 'Long Answer Question',
      shortAnswerQuestion: 'Short Answer Question',
      multipleChoiceQuestions: 'Multiple Choice Questions',
      writeQuestionAndAnswer: 'Write The Question And The Answer',
      image: 'image',
      uploadFileFillUrl:
        'Please upload the file somewhere and put the URL at the bottom.',
      uploadFile: 'Upload File',
      file: 'File',
      text: 'Text',
    },
  },
  fa: {
    locale: 'fa',
    messages: {
      hello: 'سلام',
      login: 'ورود',
      logout: 'خروج',
      backToEvent: 'بازگشت به کلاس',
      callMentor: 'درخواست تصحیح',
      mentor: 'منتور',
      edit: 'ویرایش',
      team: 'تیم',
      readArticle: 'مطالعه مقاله',
      support: 'پشتیبانی',
      history: 'سابقه',
      watch: 'مشاهده',
      username: 'نام‌کاربری',
      password: 'گذرواژه',
      createArticle: 'ساخت مقاله جدید',
      articleName: 'نام مقاله',
      workshopName: 'نام کارگاه',
      create: 'ایجاد',
      createWorkshop: 'ساخت کارگاه جدید',
      specifyNameAndTypeOfWorkshop: 'لطفا نام و نوع کارگاه را مشخص کنید.',
      zharfaStudentSociety: 'انجمن علمی ژرفا',
      rastaScientificExtensiveSociety: 'جمع علمی-ترویجی رستا',
      end: 'پایان',
      goNext: 'برو به دست بعدی',
      retry: 'تلاش مجدد',
      pickedCorrect: 'درست چیدی',
      pickedIncorrect: 'درست نچیدی',
      checkAnswer: 'بررسی جواب',
      expertsGame: 'بازی خبرگان',
      endOfFirstLevel: 'پایان دست اول',
      startGame: 'شروع بازی',
      score: 'امتیاز',
      thereIsNoItem: 'موردی وجود ندارد!',
      createWidget: 'افزودن ویجت',
      removeState: 'حذف گام',
      createState: 'ایجاد گام',
      stateName: 'نام',
      help: 'راهنمایی',
      helpNumber: 'راهنمایی شماره',
      createHelp: 'ایجاد راهنمایی جدید',
      widgetType: 'نوع ویجت',
      wantDeleteState: 'آیا مایل به حذف این گام هستید؟',
      eventTeam: 'تیم کلاس',
      seeMore: 'مشاهده بیشتر',
      gameTheory: 'نظریه بازی‌ها',
      blockchain: 'بلاکچین',
      gravity: 'گرانش',
      AI: 'هوش مصنوعی',
      algorithm: 'الگوریتم',
      codingTheory: 'نظریه کد‌گذاری',
      chooseNextState: 'کجا بریم؟',
      next: 'بعدی',
      submit: 'ثبت',
      answer: 'پاسخ',
      submitAnswer: 'ثبت پاسخ',
      question: 'سوال',
      game: 'بازی',
      chooseTheGame: 'بازی مورد نظرتان را انتخاب کنید.',
      removeWidget: 'حذف ویجت',
      options: 'گزینه‌ها',
      back: 'بازگشت',
      longAnswerQuestion: 'سوال توضیحی',
      shortAnswerQuestion: 'سوال کوتاه پاسخ',
      multipleChoiceQuestions: 'سوال چند گزینه‌ای',
      writeQuestionAndAnswer: 'صورت سوال و پاسخ آن را وارد کنید.',
      wantRemoveWidget: 'آیا مایل به حذف این ویجت هستید؟',
      image: 'تصویر',
      uploadFileFillUrl:
        'عکس را در مکانی بارگذاری کرده و آدرس آن را در ورودی پایین قرار دهید.',
      uploadFile: 'بارگذاری فایل',
      file: 'فایل',
      text: 'متن',
    },
  },
};

export default dictionary;
